/**
 * BreadcrumbBar — Design system wrapper around AppBreadcrumbs.
 *
 * Renders inside the main content area, above page content,
 * showing the user's current navigation path.
 *
 * Props:
 *   current?: string — Override the last breadcrumb label
 *   extra?: Array<{ label: string, path?: string }> — Additional crumbs
 */
import React from 'react';
import { Box } from '@mui/material';
import AppBreadcrumbs from '../../components/AppBreadcrumbs';

export default function BreadcrumbBar({ current, extra, ...props }) {
  return (
    <Box
      sx={{
        py: 1,
        px: 0.5,
      }}
      {...props}
    >
      <AppBreadcrumbs current={current} extra={extra} />
    </Box>
  );
}
